import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { Alert, Form, Input } from 'antd';
import Swal from 'sweetalert2';
import '../Assets/Styles/pages/login.css';
import logoBPMS from '../Assets/Images/Logo-BPMS-4x-white-background.webp';
import clienteAxios from '../Utils/clienteAxios';
import Boton from '../Components/Atoms/Boton';

/**
 * Pantalla a la que llega el enlace del correo de recuperación.
 *
 * El token y el correo viajan en la URL (?token=...&email=...). El token es de un solo uso y
 * caduca; aquí solo se reenvía al backend junto con la contraseña nueva. Reutiliza el
 * aspecto del login para que se sienta como la misma puerta de entrada.
 */
const RestablecerContrasena = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const token = params.get('token');
  const email = params.get('email');
  const enlaceIncompleto = !token || !email;

  const restablecer = ({ password, password_confirmation }) => {
    if (isSubmitting) return;
    setIsSubmitting(true);

    clienteAxios
      .post('/users/resetPassword', { token, email, password, password_confirmation })
      .then((response) => {
        Swal.fire({
          icon: 'success',
          title: 'Contraseña actualizada',
          text: response?.data?.message || 'Ya puedes iniciar sesión con tu nueva contraseña.',
          confirmButtonText: 'ACEPTAR'
        }).then(() => navigate('/login'));
      })
      .catch((error) => {
        setIsSubmitting(false);
        Swal.fire({
          icon: 'error',
          title: 'No se pudo actualizar la contraseña',
          text:
            error?.response?.data?.message ||
            'Ocurrió un problema. Intenta de nuevo en unos minutos.',
          confirmButtonText: 'ACEPTAR'
        });
      });
  };

  return (
    <main className="pagina-login">
      <div className="container-login">
        <section className="wrapper-form-login" aria-labelledby="restablecer-titulo">
          <div className="wrapper-logo-bpms">
            <img className="logobpms" src={logoBPMS} alt="BPMS Operations" />
          </div>
          <h1 id="restablecer-titulo" className="login-titulo">
            Crea tu nueva contraseña
          </h1>

          {enlaceIncompleto ? (
            <>
              <Alert
                type="error"
                showIcon
                className="login-aviso"
                message="El enlace está incompleto. Solicita uno nuevo desde el inicio de sesión."
              />
              <Link to="/login">
                <Boton type="primary" block className="login-boton">
                  VOLVER AL INICIO DE SESIÓN
                </Boton>
              </Link>
            </>
          ) : (
            <Form
              onFinish={restablecer}
              layout="vertical"
              requiredMark={false}
              validateTrigger={['onChange', 'onBlur']}>
              <p className="login-ayuda">
                Cuenta: <strong>{email}</strong>
              </p>
              <Form.Item
                label="Nueva contraseña"
                name="password"
                rules={[
                  { required: true, message: 'Ingresa tu nueva contraseña' },
                  { min: 8, message: 'Debe tener al menos 8 caracteres' }
                ]}>
                <Input.Password className="cajacontraseña" autoComplete="new-password" />
              </Form.Item>
              <Form.Item
                label="Confirma la contraseña"
                name="password_confirmation"
                dependencies={['password']}
                rules={[
                  { required: true, message: 'Confirma tu nueva contraseña' },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      return !value || getFieldValue('password') === value
                        ? Promise.resolve()
                        : Promise.reject(new Error('Las contraseñas no coinciden'));
                    }
                  })
                ]}>
                <Input.Password className="cajacontraseña" autoComplete="new-password" />
              </Form.Item>
              <div className="conten-btn-iniciar-sesion">
                <Boton
                  type="primary"
                  block
                  htmlType="submit"
                  className="login-boton"
                  loading={isSubmitting}>
                  GUARDAR CONTRASEÑA
                </Boton>
              </div>
              <div className="forgot-password-link-wrapper login-volver">
                <Link to="/login" className="forgot-password-link">
                  Volver al inicio de sesión
                </Link>
              </div>
            </Form>
          )}
        </section>
      </div>
    </main>
  );
};

export default RestablecerContrasena;
